
const paths = require.context('./', true, /\.json$/).keys();
let content = []
for (let i = 0; i < paths.length; i++) {
    const file = require(`${paths[i]}`)
    content = content.concat(file)
}
export const Data = content



// WEBPACK FOOTER //
// ./src/config/zh-tw/cswap/api/basic/index.js